import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "message-input flex w-full gap-2" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "sm:w-6 sm:h-6"
}
const _hoisted_5 = {
  key: 1,
  class: "animate-spin h-5 w-5 sm:h-6 sm:w-6",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.messageContent) = $event)),
      placeholder: "Napišite poruku...",
      class: "flex-grow bg-gray-800 text-white border-2 border-gray-600 rounded-lg px-3 sm:px-4 py-2 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none text-sm sm:text-base",
      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleEnterKey && _ctx.handleEnterKey(...args)), ["prevent"]), ["enter"])),
      disabled: _ctx.isSending,
      rows: "1",
      ref: "textareaRef",
      style: {"min-height":"44px","max-height":"120px"}
    }, null, 40, _hoisted_2), [
      [_vModelText, _ctx.messageContent]
    ]),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
      class: "bg-blue-600 text-white px-3 sm:px-6 py-2 sm:py-3 rounded-lg hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 flex items-center justify-center min-w-12 sm:min-w-20 border-2 border-blue-600 flex-shrink-0",
      disabled: !_ctx.canSend || _ctx.isSending
    }, [
      (!_ctx.isSending)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[3] || (_cache[3] = [
            _createElementVNode("line", {
              x1: "22",
              y1: "2",
              x2: "11",
              y2: "13"
            }, null, -1),
            _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" }, null, -1)
          ])))
        : (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[4] || (_cache[4] = [
            _createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }, null, -1),
            _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            }, null, -1)
          ])))
    ], 8, _hoisted_3)
  ]))
}